import { SettingsApi } from 'services/ApiService';
import { logError } from 'services/logger';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AddUpdateSettings } from 'services/ApiService/Subscription/SubscriptionApiClient';

export type LanguageMutationRequest = {
    id: number,
    body: AddUpdateSettings;
};

const SETTINGS_QUERIE_KEY = 'settings';

export const settingsKeys = {
    getSettings: (icId: string | undefined) => [SETTINGS_QUERIE_KEY, 'getSettings', icId],
};

export const useGetSettings = (icId: string | undefined) => {
    const getSettings = async (icId: string) => {
        try {
            return await SettingsApi.get(icId);
        }
        catch (error) {
            logError(error);
            throw error;
        }
    };

    return useQuery({
        queryKey: settingsKeys.getSettings(icId),
        queryFn: () => getSettings(icId ?? ''),
        enabled: !!icId,
        staleTime: Infinity,
        gcTime: Infinity,
    });
};

export const useSetLanguage = (icId: string) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (request: LanguageMutationRequest) => {
            await SettingsApi.update(request.id, request.body);
        },
        onError: (error: any) => {
            logError(error);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: settingsKeys.getSettings(icId) });
        },
    });
};
